module.exports = __webpack_public_path__ + "img/pulse.84fb3ccc.svg";